import CheckoutAPICall from "../service/CheckoutAPICall";

export class CheckoutRepository {

    uploadTaxExempt = async (params) => {
        return await new CheckoutAPICall().uploadTaxExempt(params)
    }
}